import Marker from "./Marker";
import BarChart from "./Charts/BarChart";
import GroupedBarChart from "./Charts/GroupedBarChart";
import AreaChart from "./Charts/AreaChart";
import LineChart from "./Charts/LineChart";
import PieChart from "./Charts/PieChart";
import GaugeChart from "./Charts/GaugeChart";
import HistogramChart from "./Charts/HistogramChart";
import LollipopChart from "./Charts/LollipopChart";
import ScatterChart from "./Charts/ScatterChart";
import SparklineChart from "./Charts/SparklineChart";
import HeatMapChart from "./Charts/HeatMapChart";
import TablePanel from "./TablePanel";
import CounterPanel from "./CounterPanel";
import StatusPanel from "./StatusPanel";
import StackedBarChart from "./Charts/StackedBarChart";
import MeterProportionalChart from "./Charts/MeterProportionalChart";
import BoxplotChart from "./Charts/BoxplotChart";
import DonutChart from "./Charts/DonutChart";
import BubbleChart from "./Charts/BubbleChart";
import ExperimentalChoroplethChart from "./Charts/ExperimentalChoroplethChart";
import HeatMapPark from './HeatMapPark';
import MarkdownPanel from './MarkdownPanel';

export const panelKey = (g) => {
  return `${g?.id}:${g?.chart_type}`;
};

export const newReqKey = () => {
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const getPanelData = (currentDashboard, panelId) => {
  if (!currentDashboard) return { config: null, data: null, loading: false, error: '', httpStatusCode: null };
  return currentDashboard.panels[panelId] || { config: null, data: null, loading: false, error: '', httpStatusCode: null };
};

export const getAllPanelConfigs = (currentDashboard) => {
  if (!currentDashboard) return [];
  return Object.values(currentDashboard.panels)
    .map(p => p.config)
    .filter(config => config !== null);
};

export function checkHasData(data) {
  if (Array.isArray(data)) return data.length > 0;
  if (data && typeof data === "object") return Object.keys(data).length > 0;
  return Boolean(data);
}

export const chartElements = {
  marker : (chart) => <Marker key={`${chart.unique_id}`} chart={chart} />,
  bar_chart : (chart) => <BarChart key={`${chart.unique_id}`} chart={chart} />,
  groupedbar_chart : (chart) => <GroupedBarChart key={`${chart.unique_id}`} chart={chart} />,
  stackedbar_chart: (chart) => <StackedBarChart key={`${chart.unique_id}`} chart={chart} />,
  area_chart : (chart) => <AreaChart key={`${chart.unique_id}`} chart={chart} />,
  line_chart : (chart) => <LineChart key={`${chart.unique_id}`} chart={chart} />,
  pie_chart : (chart) => <PieChart key={`${chart.unique_id}`} chart={chart} />,
  gauge_chart : (chart) => <GaugeChart key={`${chart.unique_id}`} chart={chart} />,
  donut_chart : (chart) => <DonutChart key={`${chart.unique_id}`} chart={chart} />,
  boxplot_chart : (chart) => <BoxplotChart key={`${chart.unique_id}`} chart={chart} />,
  histogram_chart : (chart) => <HistogramChart key={`${chart.unique_id}`} chart={chart} />,
  heatmap_chart : (chart) => <HeatMapChart key={`${chart.unique_id}`} chart={chart} />,
  meter_proportional_chart : (chart) => <MeterProportionalChart key={`${chart.unique_id}`} chart={chart} />,
  lollipop_chart : (chart) => <LollipopChart key={`${chart.unique_id}`} chart={chart} />,
  scatter_chart : (chart) => <ScatterChart key={`${chart.unique_id}`} chart={chart} />,
  sparkline_chart : (chart) => <SparklineChart key={`${chart.unique_id}`} chart={chart} />,
  bubble_chart : (chart) => <BubbleChart key={`${chart.unique_id}`} chart={chart} />,
  table_chart : (chart) => <TablePanel key={`${chart.unique_id}`} chart={chart} />,
  counter_chart : (chart) => <CounterPanel key={`${chart.unique_id}`} chart={chart} />,
  status_chart : (chart) => <StatusPanel key={`${chart.unique_id}`} chart={chart} />,
  experimental_choropleth_chart : (chart) => <ExperimentalChoroplethChart key={`${chart.unique_id}`} chart={chart} />,
  heatmap_park : (chart) => <HeatMapPark key={`${chart.unique_id}`} chart={chart} />,
  markdown_panel : (chart) => <MarkdownPanel key={`${chart.unique_id}`} chart={chart} />,
  makemake_selector : () => null,
};

export function chartChooser(obj) {
  if (!obj.chart_type) obj.chart_type = obj.type;
  return chartElements[obj.chart_type](obj);
}

export function parseStringArrayFields(rawFields) {
  const fields = Array.isArray(rawFields)
    ? rawFields
    : typeof rawFields === "string"
      ? rawFields.split(",")
      : [];
  return fields
    .map((s) => String(s).trim())
    .filter((s) => s.length > 0);
}

export function toNumber(chart) {
  return [...chart.data.map(e => {
    return {...e, value: e.value !== null ? Number(e.value) : null}
  })]
}

export function convertToHTML(data) {
  return <div dangerouslySetInnerHTML={{__html: data}}></div>
}
